import { useEffect } from 'react';
import { X } from 'lucide-react';

export default function OrderDetailSheet({
  order,
  statusConfig,
  onClose,
  // Statut à afficher quand la fiche sait mieux que le statut de livraison
  // brut — voir pickOrderStatus. Une seule pastille, toujours.
  primaryStatus = null,
  footer = null,
  children,
}) {
  const s = primaryStatus || statusConfig[order.status] || statusConfig.pending;

  useEffect(() => {
    // Bloquer le scroll du body (admin/gestionnaire qui utilisent le scroll document)
    const scrollY = window.scrollY;
    if (scrollY > 0) {
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
    }
    return () => {
      if (scrollY > 0) {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollY);
      }
    };
  }, []);

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 50,
        display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
        background: 'rgba(10,18,40,0.55)', backdropFilter: 'blur(4px)',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '24px 24px 0 0',
          width: '100%',
          maxWidth: '520px',
          maxHeight: '90vh',
          /* Flex column: header fixe + contenu scrollable + footer fixe */
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 -24px 80px rgba(0,0,0,0.25)',
          transform: 'translateZ(0)',
          WebkitTransform: 'translateZ(0)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* ── Drag handle (fixe) ─────────────────────────────────────── */}
        <div style={{ padding: '16px 0 0', display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
          <div style={{ width: '40px', height: '4px', borderRadius: '2px', background: '#e5e7eb' }} />
        </div>

        {/* ── En-tête (fixe) ─────────────────────────────────────────
             Le statut occupait auparavant un bandeau plein pleine largeur :
             sur une commande en attente, la fiche s'ouvrait sur un pavé
             orange avant même qu'on lise le nom du client. Il tient dans une
             pastille, comme partout ailleurs dans l'app. */}
        <div style={{ padding: '14px 20px 12px', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px' }}>
            <div style={{
              fontFamily: 'Alan Sans, sans-serif',
              fontSize: '20px',
              fontWeight: 800,
              color: '#0f172a',
              minWidth: 0,
            }}>
              {order.client || '—'}
            </div>
            <button
              onClick={onClose}
              style={{
                width: '30px', height: '30px', borderRadius: '8px',
                border: '1px solid #e2e8f0', background: 'white',
                cursor: 'pointer', display: 'flex', alignItems: 'center',
                justifyContent: 'center', color: '#64748b', flexShrink: 0,
              }}
            >
              <X size={14} />
            </button>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '7px', flexWrap: 'wrap', marginTop: '7px' }}>
            <span style={{
              padding: '3px 9px', borderRadius: '7px',
              background: s.bg, border: `1px solid ${s.border}`,
              fontSize: '11px', fontWeight: 700, color: s.color,
              whiteSpace: 'nowrap',
            }}>
              {s.label}
            </span>
            <span style={{ fontSize: '12px', color: '#94a3b8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {[order.store, order.order_number ? `#${order.order_number}` : null].filter(Boolean).join(' · ')}
            </span>
          </div>
        </div>

        {/* ── Contenu scrollable ─────────────────────────────────────── */}
        <div style={{
          flex: 1,
          overflowY: 'scroll',
          WebkitOverflowScrolling: 'touch',
          overscrollBehavior: 'contain',
          padding: '0 20px',
          paddingBottom: 'max(100px, calc(env(safe-area-inset-bottom, 0px) + 90px))',
        }}>
          {children}
        </div>

        {/* ── Footer fixe (hors du scroll) ───────────────────────────── */}
        {footer && (
          <div style={{
            flexShrink: 0,
            padding: '12px 20px',
            paddingBottom: 'max(16px, env(safe-area-inset-bottom, 16px))',
            borderTop: '1px solid #f1f5f9',
            background: 'white',
          }}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
